
export const customStyles = {
    control: (provided, state) => ({
        ...provided,
        minHeight: 44,
        height: "auto",
        backgroundColor: "var(--wlj-field-bg, #f4f6fb)",
        color: "var(--label)",
        borderRadius: 10,
        border: "1px solid var(--wlj-field-border, #e4e7ec)",
        boxShadow: state.isFocused ? "var(--wlj-focus-ring, 0 0 0 3px rgba(0, 65, 159, 0.12))" : "none",
        cursor: "pointer",
        transition: "border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease",
        "&:hover": {
            borderColor: "var(--buttonBase, #00419f)",
            backgroundColor: "var(--background-color3, #fff)",
        },
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: "2px 12px",
        overflow: "hidden",
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        paddingRight: 6,
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: "var(--wlj-muted, #667085)",
        padding: 6,
        "&:hover": {
            color: "var(--buttonBase, #00419f)",
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: "var(--wlj-muted, #667085)",
        padding: 6,
        "&:hover": {
            color: "var(--buttonBase, #00419f)",
        },
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
    singleValue: (provided) => ({
        ...provided,
        color: "var(--mainTextColor, #101828)",
        fontSize: 13,
        fontWeight: 500,
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "var(--label, #92929d)",
        fontSize: 13,
        margin: 0,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "calc(100% - 8px)",
    }),
    input: (provided) => ({
        ...provided,
        color: "var(--mainTextColor, #101828)",
        fontSize: 13,
        margin: 0,
        padding: 0,
        background: "transparent",
        border: "none",
        boxShadow: "none",
        minHeight: 0,
        width: "auto",
    }),
    option: (provided, state) => ({
        ...provided,
        borderRadius: 8,
        margin: "2px 4px",
        padding: "10px 12px",
        fontSize: 13,
        fontWeight: state.isSelected ? 600 : 500,
        cursor: "pointer",
        backgroundColor: "transparent",
        background: state.isSelected
            ? "var(--wlj-active-bg)"
            : state.isFocused
                ? "var(--wlj-hover-bg)"
                : "transparent",
        color: state.isSelected || state.isFocused
            ? "var(--buttonBase, #00419f)"
            : "var(--wlj-nav-ink, #444444)",
        "&:hover": {
            background: "var(--wlj-active-bg)",
            color: "var(--buttonBase, #00419f)",
        },
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: "var(--wlj-glass-bg, rgba(255, 255, 255, 0.62))",
        background: "var(--wlj-glass-bg, rgba(255, 255, 255, 0.62))",
        backdropFilter: "var(--wlj-glass-blur, blur(22px) saturate(180%))",
        WebkitBackdropFilter: "var(--wlj-glass-blur, blur(22px) saturate(180%))",
        border: "1px solid var(--wlj-glass-edge, rgba(16, 24, 40, 0.1))",
        borderRadius: 4,
        boxShadow: "var(--wlj-glass-shadow, 0 12px 32px rgba(16, 24, 40, 0.14))",
        overflow: "hidden",
        zIndex: 1300,
        marginTop: 6,
        padding: 4,
    }),
    menuList: (provided) => ({
        ...provided,
        backgroundColor: "transparent",
        maxHeight: 240,
        padding: 6,
        scrollbarWidth: "none",
        msOverflowStyle: "none",
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 1300,
    }),
};
